import { useSelector } from 'react-redux';
import type { RootState } from '../../../redux/store';

// Reactive read of the selected store — unlike the localStorage-backed
// getActiveStoreId() snapshot, this triggers a re-render (and therefore a
// refetch of anything keyed on it) whenever the user switches stores.
export const useActiveStoreId = (): string | null =>
  useSelector((state: RootState) => state.stores.activeStoreId);
